import React from "react";
import ReactDOM from "react-dom/client";
import AlertTemplate from 'react-alert-template-basic';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore } from "redux";
import { Provider } from "react-redux";
import rootReducer from "./reducers";
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import "./i18n";  // Ensure i18n is initialized
import { loadState, saveState } from "./localStorage";
import i18n from 'i18next';  // Import i18n directly

const persistedState = loadState();
const store = createStore(rootReducer, persistedState);

store.subscribe(() => {
  saveState(store);
});

const options = {
  position: positions.TOP_RIGHT,
  timeout: 3000,
  offset: '30px',
  transition: transitions.SCALE,
};

// Wait for i18n to initialize before rendering the App
i18n.on('initialized', () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <Provider store={store}>
      <AlertProvider template={AlertTemplate} {...options}>
        <App />
      </AlertProvider>
    </Provider>
  );

  serviceWorker.register();  // Register service worker
});
